export default "__VITE_ASSET__32a297c1__"